import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';
import { useAuth } from '../../contexts/AuthContext';
import NotificationPreferences from './components/NotificationPreferences';
import { useLanguage } from '../../contexts/LanguageContext';

const ROLE_LABELS = {
  admin: 'Admin',
  site_manager: 'Site Manager',
  worker: 'Worker',
  client: 'Client',
};

const ProfileSettings = () => {
  const navigate = useNavigate();
  const { user, userProfile } = useAuth();
  const { t } = useLanguage();

  const userName = userProfile?.full_name || user?.email?.split('@')?.[0] || 'User';
  const userEmail = user?.email || userProfile?.email || '';
  const roleLabel = ROLE_LABELS?.[userProfile?.role] || userProfile?.role || 'Unknown';

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-[72px]">
        <div className="max-w-3xl mx-auto px-4 py-8">
          {/* Page Header */}
          <div className="flex items-center gap-3 mb-8">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center justify-center w-9 h-9 rounded-md border border-border hover:bg-muted transition-colors"
            >
              <Icon name="ArrowLeft" size={18} />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-foreground">{t('profileSettingsPageTitle')}</h1>
              <p className="text-sm text-muted-foreground">{t('profileSettingsPageSubtitle')}</p>
            </div>
          </div>

          {/* Profile Info Card */}
          <div className="bg-card rounded-lg shadow-elevation-1 p-6 mb-6">
            <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
              <Icon name="User" size={18} className="text-accent" />
              {t('yourAccount')}
            </h2>
            <div className="space-y-3">
              <div className="flex items-center gap-3 py-2 border-b border-border">
                <span className="text-sm text-muted-foreground w-28 flex-shrink-0">{t('fullNameLabel')}</span>
                <span className="text-sm font-medium text-foreground">{userName}</span>
              </div>
              <div className="flex items-center gap-3 py-2 border-b border-border">
                <span className="text-sm text-muted-foreground w-28 flex-shrink-0">{t('emailAddressLabel')}</span>
                <span className="text-sm font-medium text-foreground">{userEmail}</span>
              </div>
              <div className="flex items-center gap-3 py-2">
                <span className="text-sm text-muted-foreground w-28 flex-shrink-0">{t('roleLabel')}</span>
                <span className="text-sm font-medium text-foreground">{roleLabel}</span>
              </div>
            </div>
          </div>

          {/* Notification Preferences Card */}
          <NotificationPreferences />
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;
